import React from 'react';
import seedProductionLogo from '../images/seedproductoion-logo.png';
import productionimg from "../images/seedproduction-image.jpeg"
const SeedProduction = () => {
  return (
    <div className="page service-page">
      <section className="service-hero-banner">
        <img src={seedProductionLogo} alt="Seed Production" className="service-hero-banner__image" />
        <div className="service-hero-banner__overlay">
          <h1>Seed Production</h1>
        </div>
      </section>

      <div className="container sp-wide-container">
        <section className="sp-showcase-section">
          {/* <h1 className="sp-title">Seed Production</h1> */}

          <div className="sp-showcase-row">
            <div className="sp-media">
              {/* <span className="sp-badge" aria-hidden="true">🧠</span> */}
              <img
                src={productionimg}
                alt="Field pollination handling in seed production"
                loading="lazy"
              />
            </div>

            <div className="sp-content">
              <p>
                Seeds are produced by a highly qualified and experienced production team with a strong focus on
                genetic purity and germination consistency to support vigorous seedlings and reliable crop output.
                The company is engaged in contract seed production for reputed partners while meeting strict
                production standards.
              </p>

              <p>
                Production centers are managed across varied climatic zones to support multiple vegetable crops
                through selected grower networks and monitored field systems.
              </p>

              <p>
                Clients receive periodic digital photographs and crop-status updates from production fields.
                Regular inspections, timely phytosanitary compliance, and export-ready documentation help maintain
                consistency and trust throughout the production cycle.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SeedProduction;